// extracted by mini-css-extract-plugin
export default {"text-box-story":"Story_text-box-story__7aHIE","portrait":"Story_portrait__didlJ"};